import { FORGET_CART } from '../types';
export var forgetCart = function forgetCart() {
  return {
    type: FORGET_CART
  };
};